import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import Markdown, { defaultUrlTransform } from 'react-markdown';
import { INLINE_ID_PREFIX, remarkInlineIds } from './remarkInlineIds.js';
// The default transform drops unknown schemes, so the plugin's `agent-id:` links pass through here.
const urlTransform = (url) => (url.startsWith(INLINE_ID_PREFIX) ? url : defaultUrlTransform(url));
export function AssistantMarkdown(props) {
    const { content, citations, renderInlineId } = props;
    // The citations let the plugin link an ID the model shortened.
    const remarkPlugins = useMemo(() => [[remarkInlineIds, { knownIds: citations?.map((c) => c.id) ?? [] }]], [citations]);
    const components = useMemo(() => ({
        a: ({ href, children }) => {
            if (href?.startsWith(INLINE_ID_PREFIX)) {
                const id = href.slice(INLINE_ID_PREFIX.length);
                return _jsx(_Fragment, { children: renderInlineId(id, citations?.find((c) => c.id === id)?.kind) });
            }
            return (_jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", children: children }));
        },
    }), [citations, renderInlineId]);
    // Images are off: a model-written image URL would fire a request on render (prompt injection via document text).
    return (_jsx(Markdown, { remarkPlugins: remarkPlugins, urlTransform: urlTransform, components: components, disallowedElements: ['img'], unwrapDisallowed: true, children: content }));
}
//# sourceMappingURL=AssistantMarkdown.js.map